import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { communicationApi } from '../services/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Mail, Send, Loader2, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const EmailPage = () => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ recipient_email: '', subject: '', message: '' });
  const [history, setHistory] = useState([]);

  const handleSend = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await communicationApi.sendEmail(form);
      toast.success('Email envoye avec succes');
      setHistory(prev => [{ ...form, timestamp: new Date().toISOString(), status: 'sent', id: res.data.email_id }, ...prev]);
      setForm({ recipient_email: '', subject: '', message: '' });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur lors de l\'envoi');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (d) => { try { return new Date(d).toLocaleString('fr-FR'); } catch { return d; } };

  return (
    <Layout>
      <div className="space-y-6" data-testid="email-page">
        <div>
          <h1 className="font-heading font-bold text-xl md:text-2xl text-slate-900">Email professionnel</h1>
          <p className="text-slate-500 text-sm mt-1">Envoyez des emails personnalises aux clients</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Card className="border-slate-200 shadow-sm rounded-lg">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Mail className="w-5 h-5 text-[#0066FF]" />
                Nouvel Email
              </CardTitle>
              <CardDescription>Envoyez un email personnalise a un client</CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSend} className="space-y-4">
                <div className="space-y-2">
                  <Label>Destinataire *</Label>
                  <Input type="email" placeholder="client@email.com" value={form.recipient_email} onChange={e => setForm({...form, recipient_email: e.target.value})} required className="rounded-lg" data-testid="email-recipient" />
                </div>
                <div className="space-y-2">
                  <Label>Sujet *</Label>
                  <Input placeholder="Objet de l'email" value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} required className="rounded-lg" data-testid="email-subject" />
                </div>
                <div className="space-y-2">
                  <Label>Message *</Label>
                  <Textarea placeholder="Redigez votre message ici..." value={form.message} onChange={e => setForm({...form, message: e.target.value})} required className="rounded-lg min-h-[280px] resize-y" data-testid="email-message" />
                </div>
                <Button type="submit" className="w-full bg-[#0066FF] hover:bg-[#0052CC] rounded-lg" disabled={loading} data-testid="email-send-btn">
                  {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Send className="w-4 h-4 mr-2" />}
                  Envoyer l'email
                </Button>
              </form>
            </CardContent>
          </Card>

          <Card className="border-slate-200 shadow-sm rounded-lg">
            <CardHeader>
              <CardTitle className="text-lg">Historique des envois</CardTitle>
              <CardDescription>Emails envoyes durant cette session</CardDescription>
            </CardHeader>
            <CardContent>
              {history.length === 0 ? (
                <div className="text-center py-12 text-slate-400">
                  <Mail className="w-12 h-12 mx-auto mb-3 opacity-50" strokeWidth={1} />
                  <p>Aucun email envoye</p>
                </div>
              ) : (
                <div className="space-y-3 max-h-[500px] overflow-y-auto">
                  {history.map((item, i) => (
                    <div key={i} className="p-3 bg-slate-50 rounded-lg border border-slate-100">
                      <div className="flex items-center gap-2 mb-1">
                        <CheckCircle2 className="w-4 h-4 text-emerald-500" />
                        <span className="text-xs text-slate-500">{formatDate(item.timestamp)}</span>
                      </div>
                      <p className="text-sm font-medium text-slate-900 truncate">{item.subject}</p>
                      <p className="text-xs text-slate-500 truncate">A: {item.recipient_email}</p>
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default EmailPage;
